import React, {ComponentType, PropsWithChildren} from 'react';
import clsx from 'clsx';

import styles from './TextHelper.module.css';

interface TextHelperProps {
  component?: ComponentType<any> | string
  type: 'success' | 'alert'

  [x: string]: any
}

const TextHelper = (
  {
    className,
    component = 'div',
    children,
    type,
    ...rest
  }: PropsWithChildren<TextHelperProps>
) => {
  const combinedClasses = clsx(className, styles.root, styles[type]);

  return React.createElement(component, {...rest, className: combinedClasses}, children);
};

export default TextHelper;